module.exports = __webpack_public_path__ + "static/img/zsth2.01f73ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/zsth2.jpg
// module id = L1N3
// module chunks = 0